import { BASE_API_URL, LOG } from '../constants';
import { AppService, HTTPHeaders } from './app.service';

const options = AppService.options();
export const logService = {
  get_logs: async (data) => {
    const headers = HTTPHeaders();
    headers.headers['Content-type'] = 'application/json';
    const response = await AppService.makeRequest(BASE_API_URL + LOG.LOGS, {
      ...options,
      ...headers,
      body: JSON.stringify(data),
    });
    return response;
  },
  get_module: async (data) => {
    const headers = HTTPHeaders();
    headers.headers['Content-type'] = 'application/json';
    const reqOptions = {
      method: 'GET',
    };
    const URL = `${BASE_API_URL + LOG.MODULE}?${new URLSearchParams(
      data
    ).toString()}`;
    const response = await AppService.makeRequest(URL, {
      ...reqOptions,
      ...headers,
    });
    return response;
  },

  get_tardy_logs: async (data) => {
    const headers = HTTPHeaders();
    headers.headers['Content-type'] = 'application/json';
    const response = await AppService.makeRequest(BASE_API_URL + LOG.TARDY, {
      ...options,
      ...headers,
      body: JSON.stringify(data),
    });
    return response;
  },
};
